import {
  BedDouble,
  Camera,
  Dumbbell,
  Plane,
  ShoppingBag,
  TreePalm,
  Waves,
  type LucideIcon,
} from 'lucide-react'
import type { BusinessCategory } from '@/components/public/CreateYourPage'

/**
 * As 7 categorias do BeWave Explore — a divisão do catálogo. Espelham o enum
 * `School.business_category` e as keys de ExploreCategory (dois testes de Ruby
 * seguram as três listas juntas).
 *
 * Não são o filtro do /explore: lá quem filtra são os 32 SERVIÇOS
 * (ServiceFilters). A categoria aparece no formulário de configuração da página
 * pública, onde a escola diz em que divisão ela está, e organiza a ordem do
 * catálogo.
 *
 * Vive em lib/ e não dentro de um componente porque hoje é lida por dois lugares
 * que não se conhecem — as configurações e a vitrine — e morava num terceiro que
 * deixou de existir.
 */
export const BUSINESS_CATEGORIES: {
  key: BusinessCategory
  label: string
  icon: LucideIcon
}[] = [
  { key: 'esportes', label: 'Esportes', icon: Waves },
  { key: 'hospedagem', label: 'Hospedagem', icon: BedDouble },
  { key: 'turismo', label: 'Turismo', icon: Plane },
  { key: 'equipamentos', label: 'Equipamentos', icon: ShoppingBag },
  { key: 'performance', label: 'Performance', icon: Dumbbell },
  { key: 'conteudo', label: 'Conteúdo', icon: Camera },
  { key: 'experiencias', label: 'Experiências', icon: TreePalm },
]
